const e="linear",n="inverse",i="exponential";export{i as DISTANCE_EXPONENTIAL,n as DISTANCE_INVERSE,e as DISTANCE_LINEAR};
